import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';

export interface MatchmakingApplyFundNonProfitLink {
  id: number;
  created: string;
  fund: {
    id: number;
    name: string;
  };
}

export interface MatchmakingApplyFundNonProfitLinksResponse {
  results: MatchmakingApplyFundNonProfitLink[];
}

export const useGetMatchmakingApplyFundNonProfitLinks = () => {
  const [fetch, response] = useRequest<MatchmakingApplyFundNonProfitLinksResponse>();

  const getMatchmakingApplyFundNonProfitLinks = useCallback(() => {
    return fetch(API.paths.matchmaking_apply_list_non_profit_links, 'get');
  }, [fetch]);

  return [getMatchmakingApplyFundNonProfitLinks, response] as const;
};
